
// USER SELF SETUP
export const SELF_SETUP_NEW_ORG_USER_REQUEST = 'self_setup_new_org_user_request';
export const SELF_SETUP_NEW_ORG_USER_SUCCESS = 'self_setup_new_org_user_success';
export const SELF_SETUP_NEW_ORG_USER_FAILURE = 'self_setup_new_org_user_failure';
export const SELF_SETUP_NEW_ORG_USER_RESET = 'self_setup_new_org_user_reset';